var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[(!_vm.loggedIn)?_c('Banner'):_vm._e(),_c('ServicesSlides')],1)}
var staticRenderFns = []

export { render, staticRenderFns }